import { motion } from 'motion/react';
import { forwardRef } from 'react';

import styles from './styles.module.css';

interface AvatarProps {
  src: string;
  alt: string;
}

const Avatar = forwardRef<HTMLDivElement, AvatarProps>(({ src, alt }, ref) => {
  return (
    <motion.div
      className={styles.avatar}
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <video
        src={src}
        autoPlay
        playsInline
        controls={false}
        muted={true}
        loop={true}
        disableRemotePlayback
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '50%',
          display: 'block',
        }}
        aria-label={alt}
      />
    </motion.div>
  );
});

Avatar.displayName = 'Avatar';

export { Avatar };
